import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ICompanyContacts, IContact, ILeadData } from '../../../../models/leads/leads.model';
import { PhoneNumberHelper } from '../../../../helper/phone-number.helper';
import { LOCALE_KEY } from '../../../../services/user-service/user-token.service';
import { DateTimeHelper } from '../../../../helper/date-time.helper';
import { ContactHelper } from '../../../../helper/contact.helper';

@Component({
  selector: 'fi-request-contacts',
  templateUrl: './request-contacts.component.html',
  styleUrls: ['./request-contacts.component.scss'],
  standalone: false,
})
export class RequestContactsComponent implements OnInit, OnChanges {
  @Input() contactToDisplay: IContact;
  @Input() companyContacts: ICompanyContacts[];
  @Input() leadData: ILeadData;

  dateTimeHelper = DateTimeHelper;

  constructor() {
  }

  ngOnInit(): void {
    this.filterCompanyContacts();
  }

  ngOnChanges( changes: SimpleChanges ): void {
    if ( changes && changes.companyContacts ) {
      this.filterCompanyContacts();
    }
  }

  get contactPhone(): string {
    return PhoneNumberHelper
      .getPhoneNumber(this.contactToDisplay?.PhonePrefix, this.contactToDisplay?.Phone);
  }

  get contactMobile(): string {
    return PhoneNumberHelper
      .getPhoneNumber(this.contactToDisplay?.MobilePrefix, this.contactToDisplay?.Mobile);
  }

  getLanguage(): string {
    return sessionStorage.getItem(LOCALE_KEY);
  }

  private filterCompanyContacts(): void {
    this.companyContacts = this.companyContacts?.filter(contact => contact.Email !== this.contactToDisplay?.Email);
  }

  protected readonly ContactHelper = ContactHelper;
}
